import { useEffect, useRef, useState } from 'react'

const COUNTER_ANIMATION_DURATION_MS = 450

const easeOutCubic = (t) => 1 - (1 - t) ** 3

export default function useAnimatedCounter(targetValue, duration = COUNTER_ANIMATION_DURATION_MS) {
  const [displayValue, setDisplayValue] = useState(targetValue)
  const currentValueRef = useRef(targetValue)

  useEffect(() => {
    const startValue = currentValueRef.current

    if (startValue === targetValue) return undefined

    const delta = targetValue - startValue
    let startTimestamp = null
    let frameId = null

    const tick = (timestamp) => {
      if (startTimestamp === null) startTimestamp = timestamp
      const progress = Math.min((timestamp - startTimestamp) / duration, 1)
      const nextValue = startValue + delta * easeOutCubic(progress)
      currentValueRef.current = nextValue
      setDisplayValue(Math.round(nextValue))

      if (progress < 1) {
        frameId = requestAnimationFrame(tick)
      } else {
        currentValueRef.current = targetValue
      }
    }

    frameId = requestAnimationFrame(tick)

    return () => {
      if (frameId !== null) cancelAnimationFrame(frameId)
    }
  }, [targetValue, duration])

  return displayValue
}
